import * as TYPE from '../types';
import axios from 'axios';
import { api } from '../static';

export function getUserData(token, params, router) {
  return async (dispatch) => {
    try {
      let response = await axios.get(process.env.BASE_URL + api.getMerchant, {
        headers: { authorization: token },
        params: params,
      });
      console.log({ response });
      if (response.data.status_code == 200) {
        dispatch({
          type: TYPE.USER_DATA_FOUND,
          payload: response.data.data,
        });
      }
    } catch (error) {
      if (error.response.data.status_code === 401) {
        localStorage.setItem('token', '');
        router.push('/login'); //as this API call is fired before interceptor is mounted, handling rerouting to login page here
      }
    }
  };
}
